import { render, staticRenderFns } from "./deptList.vue?vue&type=template&id=71076b38"
import script from "./deptList.vue?vue&type=script&lang=js"
export * from "./deptList.vue?vue&type=script&lang=js"
import style0 from "./deptList.vue?vue&type=style&index=0&id=71076b38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports